import { END_POINTS } from '../constants/urls';
import emptySplitApi from '../utils/rtk';

interface CommonResponseType {
  statusCode: number;
  message: string;
}

export const FeedbackApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({

    getFeedbacks: builder.query<
      any,
      { page: number; limit: number; search?: string }
    >({
      query: ({ page, limit, search }) => ({
        url: `${END_POINTS.feedbacks}?page=${page}&limit=${limit}${search ? `&search=${search}` : ''
          }`,
        method: 'GET',
      }),
    }),
  }),
});

export const {
  useLazyGetFeedbacksQuery
} = FeedbackApi;
